export default __webpack_public_path__ + "static/course3-77695cf4fe088136587c89a5186aaf6a.jpg";